import React, { Component } from 'react';
import { BrowserRouter as Router, Link, Route } from 'react-router-dom';
import "./style.css"

const MenuGlobal = ({ color = '#1e3622' }) => {
    const path = window.location.pathname;
    return (
        <nav id="menu" role="navigation" className="menu">
            <ul>
                <li className={path === "/" ? "active" : "inactive"}><Link to={process.env.PUBLIC_URL + '/'} className="text-menu" style={{ color: color }}>Beranda</Link></li>
                <li className={path === "/data" ? "active" : "inactive"}><Link to={process.env.PUBLIC_URL + '/data'} className="text-menu" style={{ color: color }}>Dataset</Link></li>
                <li className={path === "/organisasi" ? "active" : "inactive"}><Link to={process.env.PUBLIC_URL + '/organisasi'} className="text-menu" style={{ color: color }}>Organisasi</Link></li>
                <li className={path === "/kategori" ? "active" : "inactive"}><Link to={process.env.PUBLIC_URL + '/kategori'} className="text-menu" style={{ color: color }}>Kategori</Link></li>
                <li className={path === "/info-grafis" ? "active" : "inactive"}><Link to={process.env.PUBLIC_URL + '/info-grafis'} className="text-menu" style={{ color: color }}>Info Grafis</Link></li>
                <li><a href="http://sigikab.ina-sdi.or.id/" target="_blank" className="text-menu" style={{ color: color }}>Geoportal</a></li>
                <li className={path === "/kritik-saran" ? "active" : "inactive"}><Link to={process.env.PUBLIC_URL + '/kritik-saran'} className="text-menu" style={{ color: color }}>Kritik & Saran</Link></li>
            </ul>
        </nav>
    )
}

export default MenuGlobal